<div class="container" fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center center">
    <div fxLayout="row" fxLayoutGap="50px" fxLayoutWrap fxLayoutAlign="space-around center">
        <button @fadeIn mat-raised-button class="custom-button button-image-1"
            *ngIf="user?.Privileges?.includes(systemID.IMLK_MANEGER)" (click)="goToSystem(systemID.IMLK_MANEGER)">
            {{'IMLK_MANEGER'|translate}}
        </button>
        <button @fadeIn mat-raised-button class="custom-button button-image-2"
            *ngIf="user?.Privileges?.includes(systemID.IMLK_VIEWER)" (click)="goToSystem(systemID.IMLK_VIEWER)">
            {{'IMLK_VIEWER'|translate}}
        </button>
        <button mat-raised-button class="custom-button button-image-3"
            *ngIf="user?.Privileges?.includes(systemID.WORKFLOW_ADMIN)" (click)="goToSystem(systemID.WORKFLOW_ADMIN)">
            {{'WORKFLOW_ADMIN'|translate}}
        </button>
    </div>
    <div fxLayout="row" fxLayoutGap="50px" fxLayoutWrap fxLayoutAlign="space-around center">
        <button @fadeIn mat-raised-button class="custom-button button-image-4"
            *ngIf="user?.Privileges?.includes(systemID.WORKFLOW_END_USER)"
            (click)="goToSystem(systemID.WORKFLOW_END_USER)">
            {{'WORKFLOW_END_USER'|translate}}
        </button>
        <button @fadeIn mat-raised-button class="custom-button button-image-5"
            *ngIf="user?.Privileges?.includes(systemID.DEWAN_ADMIN)" (click)="goToSystem(systemID.DEWAN_ADMIN)">
            {{'DEWAN_ADMIN'|translate}}
        </button>
        <button @fadeIn mat-raised-button class="custom-button button-image-6"
            *ngIf="user?.Privileges?.includes(systemID.DEWAN_END_USER)" (click)="goToSystem(systemID.DEWAN_END_USER)">
            {{'DEWAN_END_USER'|translate}}
        </button>
    </div>
</div>